import React, {Component} from 'react';
import { connect } from 'react-redux';
import Cta from '../base/cta';
import {limitTwoDecimals} from '../../utils/helpers';

class SimulacionIntro extends Component {

    constructor(props) {
        super(props);
        this.state = {
          data: {},
          totals : {
              pm:{
                  price_increase: 0
              },
              shell:{
                  price_increase: 0,
                  max_price: 0,
                  min_price: 0
              }
          }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let _self = this;
        let _state = _self.state;
        _state.data = nextProps.data;
        _self.calculateTotals(_state.data);
        _self.setState(_state);
    }

    calculateTotals(data){
        let _self = this;
        let _state = _self.state;

        _state.totals = {
            pm:{
                price_increase: 0
            },
            shell:{
                price_increase: 0,
                max_price: 0,
                min_price: 0
            }
        };

        if(Object.keys(data).length > 0) {
            data.details.general_simulation.pm.forEach(prod => {
                _state.totals.pm.price_increase += prod.price_increase;
            });

            data.details.general_simulation.shell.forEach(prod => {
                _state.totals.shell.price_increase += prod.price_increase;
                _state.totals.shell.max_price += prod.max_price;
                _state.totals.shell.min_price += prod.min_price;
            });

            _self.setState(_state);
        }
    }

    render(){
        let _self = this;
        let data = _self.props.data;
        let productShortnames = {};

        if(data) {
            if (data.cluster_weights) {
                data.cluster_weights.forEach(cluster => {
                    productShortnames[cluster.product_id] = cluster.product_shortname;
                });
            }
        }

        return (
            <div>
                <div className="simulador_simulacion_main-content_sim-intro">
                    <div className="simulador_simulacion_main-content_sim-intro_sim-box">
                        <table className='c-table strategy'>
                            <thead className="no-border">
                            <tr className="prime-marker">
                                <td className="prime-marker-font">Prime marker</td>
                                {data.details && data.details.general_simulation.pm.map(el =>
                                    <td key={el.product_id}>{productShortnames[el.product_id]}</td>
                                )}
                                <td>Total</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className="bordeable">
                                <td className="prime-marker-font">Aumento (%)</td>
                                {data.details && data.details.general_simulation.pm.map((el,k) => {
                                    return <td key={el.product_id}>
                                        <input name={productShortnames[el.product_id]}
                                                min="0" max="100"
                                               type="number"
                                               value={data.details.general_simulation.pm[k].price_increase}
                                               onChange={ev => {
                                                   data.details.general_simulation.pm[k].price_increase = parseFloat(ev.target.value);
                                                   if (data.details.general_simulation.pm[k].price_increase < 0) data.details.general_simulation.pm[k].price_increase = 0;
                                                   if (data.details.general_simulation.pm[k].price_increase > 100) data.details.general_simulation.pm[k].price_increase = 100;
                                                   _self.calculateTotals(data);
                                                   let _state = _self.state;
                                                   _state.data = data;
                                                   _self.setState(_state);
                                               }}/>
                                    </td>
                                })}
                                <td>{limitTwoDecimals(_self.state.totals.pm.price_increase)}</td>
                            </tr>
                            <tr className="prime-marker">
                                <td>Shell</td>
                                {data.details && data.details.general_simulation.shell.map(el =>
                                    <td key={el.product_id}>{productShortnames[el.product_id]}</td>
                                )}
                                <td className="border-bottom">Total</td>
                            </tr>
                            <tr className="prime-marker_2">
                                <td>Aumento (%)</td>
                                    {data.details && data.details.general_simulation.shell.map((el,k) => {
                                        return <td key={el.product_id}>
                                            <input name={productShortnames[el.product_id]}
                                                    min="0" max="100"
                                                   type="number"
                                                   value={data.details.general_simulation.shell[k].price_increase}
                                                   onChange={ev => {
                                                       data.details.general_simulation.shell[k].price_increase = parseFloat(ev.target.value);
                                                       if (data.details.general_simulation.shell[k].price_increase < 0) data.details.general_simulation.shell[k].price_increase = 0;
                                                       if (data.details.general_simulation.shell[k].price_increase > 100) data.details.general_simulation.shell[k].price_increase = 100;
                                                       _self.calculateTotals(data);
                                                       let _state = _self.state;
                                                       _state.data = data;
                                                       _self.setState(_state);
                                                   }}/>
                                        </td>
                                    })}
                                <td>{limitTwoDecimals(_self.state.totals.shell.price_increase)}</td>
                            </tr>
                            <tr>
                                <td>Precio Mínimo</td>
                                    {data.details && data.details.general_simulation.shell.map((el,k) => {
                                        return <td key={el.product_id}>
                                            <input name={productShortnames[el.product_id]}
                                                   type="number"
                                                   value={data.details.general_simulation.shell[k].min_price}
                                                   onFocus={ev => { ev.target.value = "" } }
                                                   onChange={ev => {
                                                       data.details.general_simulation.shell[k].min_price = parseFloat(ev.target.value);
                                                       _self.calculateTotals(data);
                                                       let _state = _self.state;
                                                       _state.data = data;
                                                       _self.setState(_state);
                                                   }}/>
                                        </td>
                                    })}
                                <td>{limitTwoDecimals(_self.state.totals.shell.min_price)}</td>
                            </tr>
                            <tr className="bordeable">
                                <td>Precio Máximo</td>
                                    {data.details && data.details.general_simulation.shell.map((el,k) => {
                                        return <td key={el.product_id}>
                                            <input name={productShortnames[el.product_id]}
                                                   type="number"
                                                   value={data.details.general_simulation.shell[k].max_price}
                                                   onChange={ev => {
                                                       data.details.general_simulation.shell[k].max_price = parseFloat(ev.target.value);
                                                       _self.calculateTotals(data);
                                                       let _state = _self.state;
                                                       _state.data = data;
                                                       _self.setState(_state);
                                                   }}/>
                                        </td>
                                    })}
                                <td>{limitTwoDecimals(_self.state.totals.shell.max_price)}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Cta click={_self.props.calculatePrices} text="Simular" simIcon centered className="medium mr-6" />
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(SimulacionIntro);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulacionintro.js